import { render, staticRenderFns } from "./WLabel.vue?vue&type=template&id=760d9e88&scoped=true&lang=pug&"
import script from "./WLabel.vue?vue&type=script&lang=js&"
export * from "./WLabel.vue?vue&type=script&lang=js&"
import style0 from "./WLabel.vue?vue&type=style&index=0&id=760d9e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760d9e88",
  null
  
)

export default component.exports